<template lang="pug">
  .user-verification
    SectionHeader(:header="header")

    .action__body
      .user-verification__list.account-list(v-if="showList")
        .account-list__header
          .account-list__header-text Никнейм на платформе

        .account-list__list(v-if="accountList.length")
          .account-list__element(
            v-for="account of accountList"
            @click="selectAccount(account)"
          ) {{ getFullName(account) }}

        .action__empty(v-else)
          | Ничего нет

      .user-verification__edit.account-edit(v-else)
        .account-edit__body
          .account-edit__data
            InputSmart.account-edit__input(
              v-for="input of inputFields"
              :key="JSON.stringify(input)"
              :item="input"
              v-model="input.value"
              :type="input.type"
            )

            .account-edit__buttons(v-if="actionButtons.length")
              Button(v-for="button of actionButtons" :key="JSON.stringify(button)" is-primary @click="button.action") {{ button.text }}

          .account-edit__screenshot
            figure.account-edit__screenshot-image(@mousemove="onImageMouseMove" :style="{ 'background-image': `url(${personImageUrl}` }")
              img(:src="personImageUrl")

            a.account-edit__screenshot-original(:href="personImageUrl" target="_blank")
              | Показать оригинал

          .account-edit__screenshot
            figure.account-edit__screenshot-image(@mousemove="onImageMouseMove" :style="{ 'background-image': `url(${passportImageUrl}` }")
              img(:src="passportImageUrl")

            a.account-edit__screenshot-original(:href="passportImageUrl" target="_blank")
              | Показать оригинал

        .account-edit__bottom
          .account-edit__bottom-heading
            | Причина отказа (если есть нарушения)

          .account-edit__bottom-reasons
            .account-edit__bottom-reason(
              v-for="(reason, i) of reasonsForDecline"
              :class="{ '--active': reason.isActive }"
              @click="selectReason(i)"
            ) {{ reason.title }}
              InlineSvg(v-if="reason.isActive" :src="require('@/assets/img/icons/close.svg')")

    .section__footer(v-if="!showList")
      Button.user-verification__confirm(
        v-if="canConfirm"
        is-secondary
        @click="sendStatus(true)"
      ) Одобрить привязку

      Button.user-verification__decline(
        v-else
        is-secondary
        @click="sendStatus(false)"
      ) Отправить на доработку

</template>

<script>
import InputSmart from '@/components/InputSmart/InputSmart'
import SectionHeader from '@/components/SectionHeader/SectionHeader'
import { mapActions } from 'vuex'

export default {
  name: 'UserVerification',

  components: {
    InputSmart,
    SectionHeader,
  },

  data: () => ({
    accountList: [],
    selectedAccount: {},
    showList: true,
    reasonsForDecline: [
      { title: 'Неверные ФИО', isActive: false, },
      { title: 'Неверные или нечитаемые фото', isActive: false, },
      { title: 'Неверно указан возраст', isActive: false, },
    ],
  }),

  computed: {
    gameName() {
      return this.$route.params.section
    },

    header() {
      return {
        title: `${this.$gameNameText(this.gameName)} / Общая верификация`,
        game: this.gameName,
      }
    },

    inputFields() {
      return [
        {
          title: 'ФИО',
          type: 'text',
          value: this.getFullName(this.selectedAccount),
        },

        {
          title: 'Дата рождения',
          type: 'text',
          value: this.selectedAccount?.birthday
        },

        {
          title: 'Адресс',
          type: 'text',
          value: this.selectedAccount?.address
        },

        {
          title: 'Телефон',
          type: 'text',
          value: this.selectedAccount?.phone
        },
      ]
    },

    actionButtons() {
      const buttons = [
        {
          text: 'Открыть профиль',
          action: () => {
            window.open(`${process.env.VUE_APP_DOMAIN}/user/id/${this.selectedAccount.account_id}`)
          },
        }
      ]

      return buttons
    },

    personImageUrl() {
      return this.selectedAccount?.person_image_url
    },

    passportImageUrl() {
      return this.selectedAccount?.passport_image_url
    },

    canConfirm() {
      let canConfirm = true

      this.reasonsForDecline.forEach(reason => {
        if (reason.isActive) {
          canConfirm = false
        }
      })

      return canConfirm
    },
  },

  async created() {
    await this.getAccountList()
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    async getAccountList() {
      this.$loading.start()

      try {
        const { data } = await this.$axios.get(`/user/account/pending-verification`)
        this.accountList = data.data
      } catch (e) {
        this.$error.handle(e)
      }

      this.$loading.finish()
    },

    selectAccount(account) {
      this.$loading.start()

      this.selectedAccount = account
      this.showList = false

      setTimeout(this.$loading.finish, 500)
    },

    selectReason(reasonIndex) {
      this.reasonsForDecline[reasonIndex].isActive = !this.reasonsForDecline[reasonIndex].isActive
    },

    async sendStatus(isConfirmed) {
      this.$loading.start()

      try {
        const id = this.selectedAccount.account_id
        const status = isConfirmed ? 'verified' : 'declined'
        const errors =
          this.reasonsForDecline.filter(reason => reason.isActive).map(reason => reason.title)

        const { data } = await this.$axios.post(`/user/account/pending-verification`, {
          id,
          status,
          errors,
        })

        if (!data.error) {
          this.showModal({
            component: 'ModalMessage',
            data: {
              type: 'success',
              title: 'Успех',
              text: 'Всё прошло как нужно! :)',
            },
          })

          this.showList = true
          this.reasonsForDecline.forEach(reason => reason.isActive = false)
          await this.getAccountList()
        }
      } catch (e) {
        this.$error.handle(e)
      }

      this.$loading.finish()
    },

    onImageMouseMove(e) {
      const zoomer = e.currentTarget
      let offsetX, offsetY, x, y

      e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
      e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX

      x = offsetX/zoomer.offsetWidth * 70
      y = offsetY/zoomer.offsetHeight * 70

      zoomer.style.backgroundPosition = x + '% ' + y + '%'
    },

    getFullName(account) {
      return `${account.first_name} ${account.middle_name} ${account.last_name}`
    }
  },
}
</script>

<style lang="scss">
.user-verification {
  height: 100%;

  &__list {
    font-family: "Futura PT";

    .account-list {
      &__header {
        border-top: 1px solid $blue-grey50;
        border-bottom: 1px solid $blue-grey50;
        width: 100%;
        padding: 16px 24px;

        &-text {
          @include caption-small;

          color: $blue-grey10;
        }
      }

      &__element {
        padding: 20px 24px;
        background: $blue-grey60;
        border-radius: 8px;
        margin-top: 8px;
        color: $white;
        cursor: pointer;
      }
    }
  }

  &__edit {
    font-family: "Futura PT";
    border-top: 1px solid $blue-grey50;

    .account-edit {
      &__body {
        display: flex;
        padding: 24px 0 40px;

        @media screen and (max-width: $breakpointMobile) {
          flex-direction: column;
        }
      }

      &__data {
        width: 100%;
      }

      &__input:not(:last-child) {
        margin-bottom: 24px;
      }

      &__buttons {
        display: flex;

        & .button {
          margin-right: 8px;
        }

        @media screen and (max-width: $breakpointMobile) {
          flex-direction: column;

          & .button:not(:last-child) {
            margin-bottom: 8px;
          }
        }
      }

      &__screenshot {
        padding-left: 24px;
        max-width: 30%;

        &-image {
          position: relative;
          overflow: hidden;
          cursor: zoom-in;

          border-radius: 8px;
          margin: 28px 0 12px;
          max-height: 277px;

          img {
            transition: opacity .5s;
            display: block;
            width: 100%;
          }

          & img:hover {
            opacity: 0;
          }
        }

        &-original {
          color: $primary60;
          cursor: pointer;
        }

        @media screen and (max-width: $breakpointMobile) {
          max-width: 100%;
          padding-left: 0;
        }
      }

      &__bottom {
        border-top: 2px solid $primary60;
        padding-top: 24px;

        &-heading {
          @include caption-small;

          color: $blue-grey10;
          margin-bottom: 12px;
        }

        &-reasons {
          display: flex;
          flex-wrap: wrap;
        }

        &-reason {
          background: $blue-grey60;
          border-radius: 8px;
          padding: 16px;
          color: $white;
          cursor: pointer;
          width: fit-content;
          margin: 0 16px 16px 0;

          & svg {
            position: relative;
            bottom: 1px;
            height: 18px;
            width: 18px;
          }
        }

        .--active {
          background: $primary60;
        }
      }
    }
  }

  &__confirm {
    background: $green60 !important;

    .button__text {
      color: $white !important;
    }

    &:hover {
      background: $green40 !important;
    }
  }

  &__decline {
    background: $red60;

    &:hover {
      background: $red40 !important;
    }
  }
}
</style>
